module.exports = __webpack_public_path__ + "img/_54A6762_t.2921ae24.jpg";